import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'offers'
const verb = HttpMethod.POST

export default class OspreyOffersImport extends BaseAction {
    constructor(dataKey) {
        const id = 'ec59e0d3-4d98-46ff-b3ef-fba98c5b2522'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getOfferImportCsvUploadUrl(params) {
        this.path = `/${resource}/import`
        this.params = params

        return fetchContentIfNeeded(this)
    }

    initiateImport(params) {
        this.path = `/${resource}/import`
        this.params = params

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-import.js